"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module base/security/1_0
 * @author Chancechen <chancechen@lexin.com>
 * @version 1.0
 * @description 安全类组件 字符串转义、判断是否合法、过滤非法链接等方法
 */
var G_URL_ILLEGAL_REG = /^javascript/i; // 非法URL匹配正则表达式

var G_INPUT_ILLEGAL_REG = /[&><"'\s]/; // 非法input匹配正则表达式

/* <BASE_NATIVE_START> */
// weex侧需要对document这个变量容错

var document = '';
/* <BASE_NATIVE_END> */

var Security = {
  /**
   * @function htmlDecode
   * @param {string} str 需要截取的字符串
   * @author Chancechen <chancechen@lexin.com>
   * @description  html字符转义解码
   * @instance
   * @returns {String}
   * @example
   * M_SECURITY.htmlDecode('&amp;'); //&
   */
  htmlDecode: function htmlDecode(str) {
    var s = ''; // 判空处理

    if (str.length == 0) {
      return '';
    } // 如果存在createElement方法


    if (document && document.createElement) {
      // 创建一个div模块
      var temp = document.createElement('div');
      temp.innerHTML = str; // 设置innerHTML为字符串

      s = temp.innerText || temp.textContent; // 获取转义解码内容
    } else {
      // 处理常用html编码特殊符
      s = str.replace(/&amp;/g, '&');
      s = s.replace(/&lt;/g, '<');
      s = s.replace(/&gt;/g, '>');
      s = s.replace(/&nbsp;/g, ' ');
      s = s.replace(/&#39;/g, '\'');
      s = s.replace(/&quot;/g, '"');
    }

    return s;
  },

  /**
   * @function htmlEncode
   * @param {string} str 需要截取的字符串
   * @author Chancechen <chancechen@lexin.com>
   * @description  html字符转义编码
   * @instance
   * @returns {String}
   * @example
   * M_SECURITY.htmlEncode('&amp;'); //&
   */
  htmlEncode: function htmlEncode(str) {
    var s = ''; // 判空处理

    if (str.length == 0) {
      return '';
    } // 如果存在createElement方法


    if (document && document.createElement) {
      // 创建一个div模块
      var temp = document.createElement('div'); // 根据是否存在textContent属性，选择使用textContent或innerText

      temp.textContent !== null || temp.textContent !== undefined ? temp.textContent = str : temp.innerText = str;
      s = temp.innerHTML; // 获取转义编码内容
    } else {
      // 处理常用html编码特殊符
      s = str.replace(/&/g, '&amp;');
      s = s.replace(/</g, '&lt;');
      s = s.replace(/>/g, '&gt;');
      s = s.replace(/ /g, '&nbsp;');
      s = s.replace(/'/g, '&#39;');
      s = s.replace(/"/g, '&quot;');
    }

    return s;
  },

  /**
   * @function isLegalUrl
   * @param {string} url 需要校验的url
   * @author Chancechen <chancechen@lexin.com>
   * @description  html字符转义编码
   * @instance
   * @returns {Boolean}
   * @example
   * M_SECURITY.isLegalUrl('javascript:;'); //false
   */
  isLegalUrl: function isLegalUrl(url) {
    // 若存在url且为字符串
    if (url && typeof url === 'string') {
      url = url.replace(/\s/g, ''); // 去除空格
    } else {
      return true;
    } // 若开头为JavaScript返回false，反之返回true


    return !G_URL_ILLEGAL_REG.test(url);
  },

  /**
   * @function urlLegalFilter
   * @param {string} str 过滤字符串
   * @author Chancechen <chancechen@lexin.com>
   * @description  html字符转义编码
   * @instance
   * @returns {Boolean}
   * @example
   * M_SECURITY.urlLegalFilter('javascript:alert(1);'); //:alert(1);
   */
  urlLegalFilter: function urlLegalFilter(str) {
    // 循环遍历链接是否非法
    while (!Security.isLegalUrl(str)) {
      str = str.replace(G_URL_ILLEGAL_REG, ''); // 将不合法字符过滤
    }

    return str;
  },

  /**
   * @function isLegalInput
   * @param {string} str 需要判断的字符串
   * @author Chancechen <chancechen@lexin.com>
   * @description  字符串输入是否合法判断
   * @instance
   * @returns {String}
   * @example
   * M_SECURITY.isLegalInput('<aaa'); //false
   */
  isLegalInput: function isLegalInput(str) {
    if (!str) {
      return true;
    }

    return !G_INPUT_ILLEGAL_REG.test(str);
  },

  /**
   * @function inputLegalFilter
   * @param {string} str 需要过滤的字符串
   * @author Chancechen <chancechen@lexin.com>
   * @description  html字符转义编码
   * @instance
   * @returns {String}
   * @example
   * M_SECURITY.inputLegalFilter('&111'); // &amp111;
   */
  inputLegalFilter: function inputLegalFilter(str) {
    // 如果存在不合法字符
    if (!this.isLegalInput(str)) {
      str = this.htmlEncode(this.htmlDecode(str));
    }

    return str;
  },

  /**
   * @function zeroSpaceFilter
   * @param {string} str 零宽字符过滤
   * @author sinchen
   * @description 零宽字符过滤
   * @returns {string}
   */
  zeroSpaceFilter: function zeroSpaceFilter(str) {
    if (str) {
      str = str.replace(/[\u200B-\u200D\u180E\u2060\uFEFF]/g, '');
    }

    return str;
  }
};
var _default = Security;
exports["default"] = _default;